import React from 'react';
import s from './OneLessonElement.module.css';

const OneLessonElement = ({type, html}) => {
	let className = s.text;

	if (type === 'photoright') {
		className = s.descriptionAndPhotoContainer;
	} else if (type === 'photoleft') {
		className = s.descriptionAndPhotoContainer;
	} else if (type === 'bigphoto') {
		className = s.bigImage;
	} else if (type === 'video') {
		className = s.videoContainer;
	} else if (type === 'manyphoto') {
		className = s.photoGalleryContainer;
	}

	return (
		<div className={s.container}>
			<div className={className} dangerouslySetInnerHTML={{__html: html}}></div>
			{/*<div className={s.videoContainer}>
                            <iframe width="100%" height="720"
                                    src="https://www.youtube.com/embed/fKopy74weus?list=RDCLAK5uy_n1yUj1SIY2iIAIiVtdlwy6z7RLFqKXmB0"
                                    title="Жадан і Собаки feat. Gogol Bordello – 5-а авеню (Офіційне відео)" frameBorder="0"
                                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                    allowFullScreen></iframe>
                        </div>
                        <div className={s.descriptionAndPhotoContainer}>
                            <div className={s.description}>
                                <p>Вайт Мандарин це активна натуральна косметика яка діє за принципом
                                    Renewal
                                    System, тобто пробудження і відновлення клітини з середини її захист
                                    та максимальне живлення</p>
                                <p>Сучасні гіганти косметичних брендів здебільшого говорять про те що
                                    їх продукти здатні проникати в глиб дерми, зволожувати,
                                    відновлювати та омолоджувати шкіру. Але що ж ми можемо бачити
                                    на їх етикетці? Склад який на 95% складається з продуктів
                                    нафтохімії, синтетичних та оклюзивних компонентів.
                                </p>
                            </div>
                            <div className={s.photo}>
                                <img src={imageRight} alt="img"/>
                            </div>
                        </div>
                        <div className={s.text}>
                            Такі компоненти створюють швидкий візуальний ефект на шкірі,
                            але вони ніяким чином позитивно не впливають на клітину та
                            внутрішні шари шкіри людини, тобто нічого корисного для людини
                            вони не несуть, а навіть більше, така косметика може завдати шкоди.
                        </div>
                        <div className={s.descriptionAndPhotoContainer}>
                            <div className={s.photo}>
                                <img src={imageLeft} alt="img"/>
                            </div>
                            <div className={s.description}>
                                <p>Місією та головною ціллю при створенні косметики Вайт Мандарин, це
                                    створення косметики, яка була б повністю натуральною мала концентрований
                                    склад, та вирішувала проблему, а не маскувала її.
                                </p>
                                <p>Тому, рішенням компанії було принципово не використовувати компоненти,
                                    які б могли зашкодити організму. Це продукти переробки нафтохімії
                                    (мінеральні олії та силікони), агресивні миючі компоненти, синтетичні
                                    консерванти та віддушки, барвники.
                                </p>
                            </div>
                        </div>
                        <div className={s.bigImage}>
                            <img src={imageCenter} alt="img"/>
                        </div>
                        <div className={s.bigText}>
                            <div className={s.bigTextTitle}>Поговоримо більш детальніше про найцікавіше!
                                Склад засобів Вайт Мандарин.
                            </div>
                            <p>Кожна рецептура продукту розроблена із урахуванням потреб клієнта та власне
                                функціональністю самого продукту.</p><p>До складу входять тільки перевірені
                            якісні європейські компоненти. Це екстракти рослин ,рослинні олії, запатентовані
                            активи провідних компаній, які містять комплекси амінокислот та пептидів, ефірні
                            олії та миючі компоненти та емоленти природнього походження.</p><p>Всі ці
                            компоненти безпосередньо впливають на якісне живлення клітини, синтез колагену
                            та еластину, який у свою чергу є будівельним матеріалом для нашої шкіри .
                            Тому Вайт Мандарин винайшов власну систему догляду, а саме Renewal System.
                            Система оновлення природньої краси.
                        </p>
                            <ul>З чого складається система Renewal System?
                                <li>⦁ Білково – вітамінне харчування
                                    <p>Для постійного біосинтезу колагену та еластину шкіри та волосся
                                        клітинні потрібні пептиди, вітаміни, мінерали та поліненасичені
                                        жирні кислоти. Саме тому до складу Продуктів Вайт Мандарин входять
                                        унікальні екстракти пророщених 5 злаків(пшениця, вівса, кукурудзи,
                                        ячмінь та жита).</p><p>Така композиція гідролізатів є ключовою у
                                        косметиці Вайт Мандарин. Екстракти синтезовані із нашого
                                        запатентованого
                                        продукту Пророщені зерна ТМ Добра Їжа. Комплекс містить велику
                                        кількість
                                        корисних речовин пептидів, амінокислот, вітамінів та входить у
                                        косметику
                                        для шкіри та волосся.
                                    </p><p>
                                        Гідролізати риса, шовку, протеїнів бобових ( є природніми потужними
                                        фітоестрогенами), Амінотеїн, Амінопептид, Амінокислотні ПАР на
                                        основі
                                        глютамінової кислоти та саркозину.
                                    </p>
                                </li>
                                <li>⦁ Антиоксидантний захист
                                    <p>Важливо щоб клітина була захищеною від впливу вільних радикалів, які
                                        призводять до її руйнування. Засоби які у своєму складі не містять
                                        антиоксидантів, є не повноцінними засобами, тому що вони не працюють
                                        на захищення клітини та самої формули.
                                    </p>
                                    <p>До складу засобів Вайт Мандарин входять найпотужніші антиоксиданти у
                                        концентрованій кількості рослинного походження. Ідеальними для
                                        обличчя будуть антиоксиданти Коензим Q10, екстракт сосни
                                        приморської, запатентований актив Пінолумін (екстракт швейцарської
                                        сосни), сніжні водорості, природні форми вітаміну С, Е та Бетта
                                        каротин.
                                    </p><p>
                                        Для волосся екстракт дикого калгану, настоянка ладану, гвоздики,
                                        розмарину, рутин, поліфлаваноїди.
                                    </p>
                                </li>
                                <li>⦁ Активізація кровообігу та лімфотоку
                                    <p>Для очищення клітини, нормалізації обмінних процесів і відновлення
                                        клітини у складі повинні бути компоненти які активують кровобіг та
                                        прискорюють лімфоток.

                                    </p>
                                    <p>З цим добре впораються ефірні олії: для волосся (ефірні олії
                                        цитрусових, розмарину, кориці, герані), для обличчя (ефірні олії
                                        мате, іланг-іланг, коріандру, кориці, цитрусових), рутин чаю,
                                        природні форми вітамінів К та РР, біологічні полімери( хітозан,
                                        насіння ріжкового дерева, алое вера).
                                    </p>
                                </li>
                            </ul>
                        </div>
                        <div className={s.photoGalleryContainer}>
                            <div className={s.imageContainer}>
                                <img src={left} alt="left"/>
                            </div>
                            <div className={s.imageContainer}>
                                <img src={center} alt="center"/>
                            </div>
                            <div className={s.imageContainer}>
                                <img src={right} alt="right"/>
                            </div>
                        </div>*/}
		</div>
	);
};

export default OneLessonElement;
